import LanguageLocalesLocal from '@helsenorge/core-utils/constants/languages';
import { getUserLanguage } from '@helsenorge/framework-utils/hn-language';

import { DEFAULT_LANGUAGE } from '../constants/constants';

export const LanguageLocales = {
  ...LanguageLocalesLocal,
  FRENCH: 'fr-FR',
  UKRAINIAN: 'uk-UA',
  INGEN: '',
} as const;

export const portalLanguages = Array.from(new Set(Object.values(LanguageLocales)));

export type LanguageLocales = (typeof LanguageLocales)[keyof typeof LanguageLocales];

export const isValidPortalLanguage = (language: LanguageLocales): boolean => {
  if (Object.values(LanguageLocales).includes(language)) {
    return true;
  } else {
    return false;
  }
};

export const getLanguageLocaleFromString = (language?: string | null): LanguageLocales | undefined => {
  if (!language) {
    return undefined;
  }
  return Object.values(LanguageLocales).includes(language as LanguageLocales) ? (language as LanguageLocales) : undefined;
};
export const getHnLanguageLocaleFromString = (language: string | null | undefined): LanguageLocalesLocal | undefined => {
  if (!language) {
    return undefined;
  }
  return Object.values(LanguageLocalesLocal).includes(language as LanguageLocalesLocal) ? (language as LanguageLocalesLocal) : undefined;
};

export const getPortalLanguage = (): LanguageLocales => {
  const userLanguage = getUserLanguage();
  const language = getLanguageLocaleFromString(userLanguage);
  return language && isValidPortalLanguage(language) ? language : DEFAULT_LANGUAGE;
};

export const isLanguageInFormDefinition = (portalLanguage: LanguageLocales, languagesInDefinition: LanguageLocales[]): boolean => {
  const languageExists = languagesInDefinition.some(x => x === portalLanguage);
  return languageExists;
};

export const isLanguageInAvailableLanguages = (language: LanguageLocales, availableLanguages: LanguageLocales[]): boolean => {
  return availableLanguages.includes(language);
};

export const getUrlLanguage = (): LanguageLocales | undefined => {
  const params = new URLSearchParams(window.location.search);
  if (params.has('lang')) {
    return getLanguageLocaleFromString(params.get('lang'));
  }
  return undefined;
};

const updateHistory = (language: LanguageLocales): void => {
  const params = new URLSearchParams(window.location.search);
  params.set('lang', language);
  window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
};

export const getPreferredLanguage = (languagesInFormDefinition: LanguageLocales[]): LanguageLocales => {
  /* language from querystring */
  const languageFromQueryString = getUrlLanguage();

  /* Language from cookie */
  const portalLanguage = getPortalLanguage();
  /* */
  const params = new URLSearchParams(window.location.search);
  /* No languages from questionnaire */
  if (languagesInFormDefinition.length === 0) {
    return DEFAULT_LANGUAGE;
    /* Language from querystring and we have at least 1 language in questionnaire */
  } else if (params.has('lang')) {
    if (languageFromQueryString && isLanguageInFormDefinition(portalLanguage, languagesInFormDefinition)) {
      return languageFromQueryString;
    }
    /* No querystring language and we have language in cookie */
  } else if (portalLanguage) {
    if (isLanguageInFormDefinition(portalLanguage, languagesInFormDefinition)) {
      return portalLanguage;
    }
  }
  /* Return default language if all other fails */
  updateHistory(DEFAULT_LANGUAGE);
  return DEFAULT_LANGUAGE;
};
